import { gql } from "graphql-request";

export const READ_TENANT_ROLE_BY_ID = gql`
  query ReadTenantRoleById($id: ID!) {
    readTenantRoleById(id: $id) {
      id
      tenantId

      departmentId
      department {
        id
        name
      }

      name
      description
      mission

      reportsToRoleId
      reportsToRole {
        id
        name
      }

      resourcingType
      coverageStatus
      externalProviderName
      coverageNotes

      createdAt
      updatedAt
      archivedAt
    }
  }
`;

export const READ_TENANT_ROLES_BY_TENANT = gql`
  query ReadTenantRolesByTenant($tenantId: ID!) {
    readTenantRolesByTenant(tenantId: $tenantId) {
      id
      tenantId

      departmentId
      department {
        id
        name
      }

      name
      description
      mission

      reportsToRoleId
      reportsToRole {
        id
        name
      }

      resourcingType
      coverageStatus
      externalProviderName
      coverageNotes

      createdAt
      updatedAt
      archivedAt
    }
  }
`;

export const READ_ADMINS = gql`
  query ReadUsersByRole($role: UserRole!) {
    readUsersByRole(role: $role) {
      id
      firstName
      lastName
    }
  }
  `;